import { TablePayload } from '@api';
import { create } from '@terminal/utils/store/createStore';

export interface VisualizationTable {
  data: TablePayload['data'];
  columnsMeta: TablePayload['columnsMeta'];
}
interface VisualizationStore {
  charts: Record<string, HTMLDivElement>;
  tables: Record<string, VisualizationTable>;
  setCharts: (uuid: string, ref: HTMLDivElement) => void;
  setTables: (uuid: string, tableData: VisualizationTable) => void;
}

export const useVisualizationStore = create<VisualizationStore>(set => ({
  charts: {},
  tables: {},
  setCharts: (uuid, ref) => {
    set(state => ({
      charts: {
        ...state.charts,
        [uuid]: ref,
      },
    }));
  },
  setTables: (uuid, tableData) =>
    set(state => ({
      tables: {
        ...state.tables,
        [uuid]: tableData,
      },
    })),
}));
